import type { IAddress } from "@bbj-types/address";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";

export interface IGetCandidateMailPreviewQuery {
  templateId: ObjectId;
  meeting?: {
    date?: string;
    time?: { hours: number; minutes: number };
    address?: IAddress;
    complementaryAddress?: string;
  };
}

export const useGetCandidateMailPreview = () => {
  const [state, execute, cancel] = axios<string, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, params: IGetCandidateMailPreviewQuery) => {
      return execute({ url: `/candidates/${id}/mail/preview`, params });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
